import { Vue, Component, Ref, Prop, Emit, Provide } from 'vue-property-decorator'
import ConfigurationAutomationGrossingShelfImmediateShelfPriorityModalBasicForm
    from '@/modules/configurationModule/detail/automation/grossing-shelf/immediate-shelf-priority/components/modal-basic-form/configuration-automation-grossing-shelf-immediate-shelf-priority-modal-basic-form.vue'
import { BModal } from 'bootstrap-vue'
import {
    ConfigurationAutomationGrossingShelfImmediateShelfPriorityModalState,
    initialConfigurationAutomationGrossingShelfImmediateShelfPriorityModalState
} from '@/modules/configurationModule/detail/automation/grossing-shelf/immediate-shelf-priority/components/modal/configuration-automation-grossing-shelf-immediate-shelf-priority-modal.model'
import {
    ConfigurationImmediateShelfPriorityAssignmentCreateRequest,
    ConfigurationImmediateShelfPriorityAssignmentPatchInBatchRequest,
    ConfigurationImmediateShelfPriorityAssignmentResponse
} from '@/modules/configurationModule/detail/automation/grossing-shelf/immediate-shelf-priority/services/configuration-immediate-shelf-priority-assignment/configuration-immediate-shelf-priority-assignment.dto'

@Component({
    components: {
        ConfigurationAutomationGrossingShelfImmediateShelfPriorityModalBasicForm
    }
})
export default class ConfigurationAutomationGrossingShelfImmediateShelfPriorityModal extends Vue {
    @Ref() readonly immediateShelfPriorityModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Provide() externalValidator = this.$validator

    @Emit()
    create(): ConfigurationImmediateShelfPriorityAssignmentCreateRequest {
        return {
            priorityId: this.state.immediateShelfPriorityAssignment.priority?.id!
        }
    }

    @Emit()
    update(): ConfigurationImmediateShelfPriorityAssignmentPatchInBatchRequest {
        return {
            id: this.state.immediateShelfPriorityAssignment.id!,
            priorityId: this.state.immediateShelfPriorityAssignment.priority?.id!
        }
    }

    state: ConfigurationAutomationGrossingShelfImmediateShelfPriorityModalState

    get updateMode(): boolean {
        return !!this.state.immediateShelfPriorityAssignment?.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    constructor() {
        super()
        this.state = initialConfigurationAutomationGrossingShelfImmediateShelfPriorityModalState()
    }

    async show(immediateShelfPriorityAssignment?: ConfigurationImmediateShelfPriorityAssignmentResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationAutomationGrossingShelfImmediateShelfPriorityModalState()
        if (immediateShelfPriorityAssignment) {
            this.state.immediateShelfPriorityAssignment = immediateShelfPriorityAssignment
        }

        this.immediateShelfPriorityModal.show()
    }

    hide(): void {
        this.immediateShelfPriorityModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.state.immediateShelfPriorityAssignment) {
                if (this.updateMode) {
                    this.update() // emits an event
                } else {
                    this.create() // emits an event
                }
            }

            this.hide()
        }
    }
}
